import { create } from "zustand";
import type { ProductListItem } from "src/api/product/productApi";
import type { SaleStatus, ProductType, PetType } from "src/types/product";

type ProductQuery = {
  productName: string;
  brandId: string;
  collectionId: string;
  saleStatus: SaleStatus | "";
  productType: ProductType | "";
  petType: PetType | "";
  isDisplay: "" | "true" | "false";
  page: number;
  size: number;
  order: string;
};

type ProductStore = ProductQuery & {
  dialogOpen: boolean;
  editItem: ProductListItem | null;

  setQuery: (next: Partial<ProductQuery>) => void;

  openCreate: () => void;
  openEdit: (item: ProductListItem) => void;
  closeDialog: () => void;
};

export const useProductStore = create<ProductStore>((set) => ({
  productName: "",
  brandId: "",
  collectionId: "",
  saleStatus: "",
  productType: "",
  petType: "",
  isDisplay: "",
  page: 1,
  size: 20,
  order: "createdAt,desc",

  dialogOpen: false,
  editItem: null,

  setQuery: (next) => set((prev) => ({ ...prev, ...next })),

  openCreate: () => set({ dialogOpen: true, editItem: null }),
  openEdit: (item) => set({ dialogOpen: true, editItem: item }),
  closeDialog: () => set({ dialogOpen: false, editItem: null }),
}));
